import React, { Component } from 'react'
import "../css/general-style.css"
import '../css/table-responsive.css'
import { getValueCookie } from '../services/cookieService'
import CustomerList from '../components/CustomerList';
import { getInformationWithData } from '../services/CABE';
import { DateFormatMAS90 } from '../functions/dateFormat';
import { pricesFormat } from '../functions/pricesFormat';

import LoadingWindow from '../components/LoadingWindow';

// Menu
import { Menu } from "../components/Menu/Menu";


export default class CustomerBalance extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        Invoice: {
            InvoiceNo: '',
            InvoiceDate: '',
            BatchNo: '',
            InvoiceType: 'IN',
            Warehouse: '000',
            SalespersonNo: '',
            Comment: '',
            FreightAmt: 0,
            Customer: {
                AddressLine1: '',
                City: '',
                CountryCode: '',
                CreditLimit: 0,
                CustomerName: '',
                CustomerNo: '',
                EmailAddress: '',
                FaxNo: '',
                PriceLevel: '',
                SalespersonNo: '',
                State: '',
                TelephoneNo: '',
                TermsCode: '',
                UDF_RUTA: '',
                ZipCode: '',
                TaxSchedule: 'NONTAX',
            }
        },
        customerList: [],
        Balance: {
            HeaderBalance: [],
            TermsCode: '',
            TotalBalance: 0,
            SelectedInvoice: '',
            Detail: []
        },
    }

    async getNewCorrelativeNewCustomer() {
        this.ModalLoading.current.showState(true);
        await this.ClearCustomerForm()
        const data = {
            type: 'Customer',
            idCompany: getValueCookie('CompanyId'),
            SalespersonNo: getValueCookie('SalesPerson')
        }



        const CustomerResult = await getInformationWithData('/customer/getList', data);

        while (true) {
            const result = await getInformationWithData('/sales/get/correlative', data)

            if (result.status.code === 1) {
                let temporal = CustomerResult.data.some((customer) => {
                    return Number(customer.CustomerNo) === Number(result.data[0].correlative)
                }
                )
                if (!temporal) {
                    const temporal = String(result.data[0].correlative).padStart(7,'0')
                    const temp = this.state.Customer
                    temp.CustomerNo = temporal
                    this.setState({ Customer: temp })
                    break
                }
            }
        }
        this.ModalLoading.current.showState(false);
    }

    async getDetailBalance(LineBalance) {
            const data = {
                idCompany: Number(getValueCookie('CompanyId')),
                InvoiceNo: LineBalance.InvoiceNo
            }
            this.ModalLoading.current.showState(true);
            const result = await getInformationWithData('/invoice/history/getInvoicePayment', data)
            if (result.status.code === 1) {
                const temporal = this.state.Balance
                temporal.Detail = result.data
                temporal.SelectedInvoice = LineBalance.InvoiceNo
                this.setState({ Balance: temporal })
            }
            this.ModalLoading.current.showState(false);
        }

    getTotalBalance() {
        let currentBalance = 0

        this.state.Balance.HeaderBalance.forEach(line => {
            currentBalance += Number(line.Balance)
        });

        const temporal = this.state.Balance
        temporal.TotalBalance = currentBalance
        this.setState({ Balance: temporal })
    }

    clearAll(){
      this.setState({
        Balance: {
                HeaderBalance: [],
                TermsCode: '',
                TotalBalance: 0,
                SelectedInvoice: '',
                Detail: []
            },
      })
    }

    handleSelectcustomer(customer) {
      // 1. Clear balances before load other customer
      this.clearAll()
      // Select the customer
      this.setState({ customerSelected: customer})
    }

    setValues() {}

    render() {
        return (
            <div>
                {/* Main menu */}
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Customer Balance</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please select a customer</p>
                </div>
                <div className='row pb-2'>
                    <div className='col-sm-1'></div>
                    <div className='col-sm-10'>
                        <div className='row pt-2'>
                            <div className='col-sm-12 col-md-12 mb-2'>
                                <CustomerList headerName='Customer' nombrePadre="Invoice" ident="InvoiceCustomerList1" Padre={this} />
                            </div>
                        </div>
                        <div className='row pt-2'>
                            <div className='col-sm-12 mb-3'>
                              <div>
                                  <div className='row pt-2'>
                                      <div className='col-sm-12 pb-2'>
                                          <h3>Terms Code: {this.state.Balance.TermsCode}</h3>
                                      </div>
                                      <div className='col-sm-12 tableFixHead'>
                                          <table className='table table-hover text-center'>
                                              <thead className='table-dark thead'>
                                                  <tr>
                                                      <th>Invoice No</th>
                                                      <th>Date</th>
                                                      <th>Due Date</th>
                                                      <th>Payment Delay Days</th>
                                                      <th>Customer Name</th>
                                                      <th>Sales Person</th>
                                                      <th></th>
                                                      <th>Balance</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  {
                                                      this.state.Balance.HeaderBalance.map((element, e) => (
                                                          <tr className={element.InvoiceNo === this.state.Balance.SelectedInvoice ? 'bg-warning' : ''} onClick={() => this.getDetailBalance(element)} key={e}>
                                                              <td>{element.InvoiceNo}</td>
                                                              <td>{element.InvoiceDate}</td>
                                                              <td>{element.InvoiceDueDate}</td>
                                                              <td>{element.PaymentDelayDays}</td>
                                                              <td>{this.state.Invoice.Customer.CustomerName}</td>
                                                              <td>{element.SalespersonNo}</td>
                                                              <td>$</td>
                                                              <td className='text-end'>{pricesFormat(element.Balance)}</td>
                                                          </tr>
                                                      ))
                                                  }
                                              </tbody>
                                              <tfoot className='tfoot'>
                                                  <tr className='table-dark'>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td></td>
                                                      <td>TOTAL:</td>
                                                      <td>$</td>
                                                      <td className='text-end'>{pricesFormat(this.state.Balance.TotalBalance)}</td>
                                                  </tr>
                                              </tfoot>
                                          </table>
                                      </div>
                                      <div className='col-sm-12'>
                                          <h3 className='text-start'>Detail: {this.state.Balance.SelectedInvoice}</h3>
                                      </div>
                                      <div className='col-sm-12 tableFixHead'>
                                          <table className='table table-hover text-center'>
                                              <thead className='table-dark thead'>
                                                  <tr>
                                                      <th>Invoice No</th>
                                                      <th>Invoice Type</th>
                                                      <th>Transaction Type</th>
                                                      <th>Transaction Date</th>
                                                      <th></th>
                                                      <th>Transaction Amount</th>
                                                  </tr>
                                              </thead>
                                              <tbody>
                                                  {
                                                      this.state.Balance.Detail.map((element, e) => (
                                                          <tr key={e}>
                                                              <td>{element.InvoiceNo}</td>
                                                              <td>{element.InvoiceType}</td>
                                                              <td>{element.TransactionType}</td>
                                                              <td>{DateFormatMAS90(element.TransactionDate)}</td>
                                                              <td className='text-end'>$</td>
                                                              <td className='text-end'>{pricesFormat(element.TransactionAmt)}</td>
                                                          </tr>
                                                      ))
                                                  }
                                              </tbody>
                                              <tfoot className='tfoot'>
                                              </tfoot>
                                          </table>
                                      </div>
                                      <div className='col-sm-6 pt-2'>
                                          {/* <OrderPDF id={"CurrentBalancePrintSalesOrder"} colorButton="blackButton" title="Sales Order Print"
                                              companyLogo={getValueCookie('DocumentsLogo')}
                                              OrderTitle="Current Balance"
                                              contactInfo={this.state.companyPrintHeader}
                                              OrderInfo1={[
                                                  "Customer No:", this.state.Invoice.Customer.CustomerNo, "Print By:", getValueCookie('userName'),
                                                  "Customer Name:", this.state.Invoice.Customer.CustomerName, "Printing Date:", FormatQueryReturnDateForReport(getActualDateUTC()),
                                                  "Phone:", this.state.Invoice.Customer.TelephoneNo, "Terms Code:", this.state.Balance.TermsCode,
                                                  "Address:", this.state.Invoice.Customer.AddressLine1, "", "",
                                                  "City", this.state.Invoice.Customer.City, "", ""
                                              ]}
                                              headerTable={["Invoice No", "Date", "Due\nDate", "Payment Delay Days", "Customer\nName", "Sales\nPerson", "", "Balance"]}
                                              bodyTable={this.state.Balance.HeaderBalance}
                                              headerBodyTable={["InvoiceNo", "InvoiceDate", "InvoiceDueDate", "PaymentDelayDays", "CustomerName", "SalespersonNo", "dolar", "Balance"]}
                                              bottomInfo={["", "", "", "", "", "TOTAL", "$", pricesFormat(this.state.Balance.TotalBalance)]}
                                              styleColumns={["ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaTextoNormal", "ColumnaCantidades", "ColumnaTextoLargo2", "ColumnaCantidades", "Dolar", "ColumnaPrecios"]}
                                              hidden={false}
                                              comment={""}
                                              keysDecimalFormat={["Balance"]}
                                              breakpoint={28}
                                              disabled={false}
                                              titleButton='Print Balance'
                                          /> */}
                                      </div>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}